"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Inbox__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_maxDataSize",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "maxDataLength",
                type: "uint256",
            },
        ],
        name: "DataTooLarge",
        type: "error",
    },
    {
        inputs: [],
        name: "GasLimitTooLarge",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "expected",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "actual",
                type: "uint256",
            },
        ],
        name: "InsufficientSubmissionCost",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "expected",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "actual",
                type: "uint256",
            },
        ],
        name: "InsufficientValue",
        type: "error",
    },
    {
        inputs: [],
        name: "L1Forked",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "origin",
                type: "address",
            },
        ],
        name: "NotAllowedOrigin",
        type: "error",
    },
    {
        inputs: [],
        name: "NotForked",
        type: "error",
    },
    {
        inputs: [],
        name: "NotOrigin",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "NotOwner",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "rollup",
                type: "address",
            },
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "NotRollupOrOwner",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "l2CallValue",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "maxSubmissionCost",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "excessFeeRefundAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "callValueRefundAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "gasLimit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "maxFeePerGas",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "RetryableData",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "val",
                type: "bool",
            },
        ],
        name: "AllowListAddressSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bool",
                name: "isEnabled",
                type: "bool",
            },
        ],
        name: "AllowListEnabledUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "messageNum",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "InboxMessageDelivered",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "messageNum",
                type: "uint256",
            },
        ],
        name: "InboxMessageDeliveredFromOrigin",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        inputs: [],
        name: "allowListEnabled",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "bridge",
        outputs: [
            {
                internalType: "contract IBridge",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "dataLength",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "baseFee",
                type: "uint256",
            },
        ],
        name: "calculateRetryableSubmissionFee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "l2CallValue",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "maxSubmissionCost",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "excessFeeRefundAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "callValueRefundAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "gasLimit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "maxFeePerGas",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "createRetryableTicket",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "l2CallValue",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "maxSubmissionCost",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "excessFeeRefundAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "callValueRefundAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "gasLimit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "maxFeePerGas",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "createRetryableTicketNoRefundAliasRewrite",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "depositEth",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "depositEth",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "getProxyAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IBridge",
                name: "_bridge",
                type: "address",
            },
            {
                internalType: "contract ISequencerInbox",
                name: "_sequencerInbox",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "isAllowed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "maxDataSize",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IBridge",
                name: "",
                type: "address",
            },
        ],
        name: "postUpgradeInit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "gasLimit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "maxFeePerGas",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "sendContractTransaction",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "gasLimit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "maxFeePerGas",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "sendL1FundedContractTransaction",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "gasLimit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "maxFeePerGas",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "sendL1FundedUnsignedTransaction",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "gasLimit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "maxFeePerGas",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "sendL1FundedUnsignedTransactionToFork",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "messageData",
                type: "bytes",
            },
        ],
        name: "sendL2Message",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "messageData",
                type: "bytes",
            },
        ],
        name: "sendL2MessageFromOrigin",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "gasLimit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "maxFeePerGas",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "sendUnsignedTransaction",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "gasLimit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "maxFeePerGas",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "sendUnsignedTransactionToFork",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "gasLimit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "maxFeePerGas",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "withdrawTo",
                type: "address",
            },
        ],
        name: "sendWithdrawEthToFork",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "sequencerInbox",
        outputs: [
            {
                internalType: "contract ISequencerInbox",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "user",
                type: "address[]",
            },
            {
                internalType: "bool[]",
                name: "val",
                type: "bool[]",
            },
        ],
        name: "setAllowList",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bool",
                name: "_allowListEnabled",
                type: "bool",
            },
        ],
        name: "setAllowListEnabled",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "l2CallValue",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "maxSubmissionCost",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "excessFeeRefundAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "callValueRefundAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "gasLimit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "maxFeePerGas",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "unsafeCreateRetryableTicket",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class Inbox__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
        this.contractName = "Inbox";
    }
    deploy(_maxDataSize, overrides) {
        return super.deploy(_maxDataSize, overrides || {});
    }
    getDeployTransaction(_maxDataSize, overrides) {
        return super.getDeployTransaction(_maxDataSize, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.Inbox__factory = Inbox__factory;
Inbox__factory.bytecode = _bytecode;
Inbox__factory.abi = _abi;
